import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/articles', label: '行业洞察' },
    { path: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <i className="ri-gamepad-line text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className="font-heading font-bold text-xl md:text-2xl text-foreground-950 whitespace-nowrap">
              木瓜玩
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap py-2 transition-colors duration-200 cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-600'
                      : 'text-foreground-50 hover:text-white'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              免费咨询
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-6 py-4">
          <div className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md text-center transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              免费咨询
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}